module.exports = __webpack_public_path__ + "img/start.21d25ee5.png";